import { ContentfulRichText, ContentfulSnackbar } from '@jbhi-fi/apis/src/contentful/types';
import { ThemeTransformer } from './ThemeTransformer';
import { IconName } from '@jbhi-fi/lanyard-ui/components/Icon';

export interface SnackbarProps {
  name: string;
  endDate?: Date;
  backgroundColor?: string;
  textColor?: string;
  url?: string;
  content?: ContentfulRichText;
  intro?: string;
  states?: Array<string>;
  includedPaths?: Array<string>;
  type?: string;
  showAgainAfter?: number;
  icon?: IconName;
  priority?: number;
  updatedAt: string;
  dismissible?: boolean;
  headingColor?: string;
}

export interface GroupedSnackbarsProps {
  main: Array<SnackbarProps>;
  sub: Array<SnackbarProps>;
  countdown: Array<SnackbarProps>;
}

export abstract class SnackbarTransformer {
  static toSnackbarProps = ({
    main,
    sub,
    countdown,
  }: {
    main: Array<ContentfulSnackbar>;
    sub: Array<ContentfulSnackbar>;
    countdown: Array<ContentfulSnackbar>;
  }): GroupedSnackbarsProps => {
    const transformEntry = (entry: ContentfulSnackbar): SnackbarProps => {
      const endDate = entry.fields?.countdownTo ? new Date(entry.fields.countdownTo) : undefined;

      return {
        name: entry.fields!.name,
        endDate: endDate,
        backgroundColor: ThemeTransformer.toContentThemeVariables(entry.fields?.theme)?.palette?.background,
        textColor: ThemeTransformer.toContentThemeVariables(entry.fields?.theme)?.palette?.text,
        headingColor: ThemeTransformer.toContentThemeVariables(entry.fields?.theme)?.palette?.heading,
        url: entry.fields?.url,
        content: entry.fields?.text,
        intro: entry.fields?.heading,
        states: entry.fields?.state,
        includedPaths: entry.fields?.paths,
        type: entry.fields?.type,
        showAgainAfter: entry.fields?.showAgainAfter,
        icon: entry.fields?.icon,
        priority: entry.fields?.priority,
        dismissible: entry.fields?.dismissible ?? true,
        updatedAt: entry.sys?.updatedAt,
      };
    };

    // Transform each entry in the main, sub, and countdown arrays
    const transformedMain = main.map(transformEntry);
    const transformedSub = sub.map(transformEntry);
    const transformedCountdown = countdown.map(transformEntry);

    return {
      main: transformedMain,
      sub: transformedSub,
      countdown: transformedCountdown,
    };
  };
}
